import { useEffect } from 'react'

export const useOnClickOutside = (ref, handler, id = null) => {
    useEffect(() => {
        const listener = event => {
            const { target } = event

            /*
             *  Do nothing if clicking ref's element or descendent elements
             *
             *  target.getAttribute('data-ref') === id is verifying to avoid the conflict when the same target/icon is clicked.
             *
             *  Eg: If we have a filter icon, popup will open when the icon is clicked and we may have given the toggle functionality on the filter icon to open and close. So to close the popup if user clicks the same icon, this hook will trigger first to close the popup and toggle functionality of the icon will opens the popup again. To avoid this conflict we are ignoring the action of onClickOutside by comparing the data-ref.
             *
             *  To ignore this conflict and functionality to work we have to pass a reference id which should be the data-ref attribute of that icon
             *
             *  Comparing with `ZUI_PORTAL`  has been added to fix a special condition when the popup has a ZuiSelect field. When an option is selected, target will be ZuiPortal and hence it act as clicked outside and closes the popup.
             */
            if (
                !ref.current ||
                ref.current.contains(target) ||
                target.getAttribute('data-ref') === id ||
                target.tagName === 'ZUI-PORTAL'
            ) {
                return
            }
            handler(event)
        }
        document.addEventListener('mousedown', listener)
        document.addEventListener('touchstart', listener)
        return () => {
            document.removeEventListener('mousedown', listener)
            document.removeEventListener('touchstart', listener)
        }
    }, [ref, handler, id])
}
